export const exaustoresConfig = [
  { 
    id: "exaustor1", 
    modulo: "9", 
    idx: "2", 
    descricao: "Exaustor 1"
  },
  { 
    id: "exaustor2", 
    modulo: "9", 
    idx: "1", 
    descricao: "Exaustor 2"
  }
];

// Função útil para obter informações de ON/OFF para cada exaustor
export const getExaustorOnOffValues = (exaustorId) => {
  const exaustor = exaustoresConfig.find(ex => ex.id === exaustorId || ex.descricao === exaustorId);
  if (!exaustor) {
    return null;
  }
  
  return {
    descricao: exaustor.descricao,
    onValue: JSON.stringify({ modulo: exaustor.modulo, idx: exaustor.idx, status: "ON" }),
    offValue: JSON.stringify({ modulo: exaustor.modulo, idx: exaustor.idx, status: "OFF" })
  };
};